import React, { useState,useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import masterService from '../../Services/masterService'
import Loader from '../../Components/Loader'
import { PhoneCode } from '../../Components';

export const EditCorporates = () => {

    const history = useHistory()
    const [loader, setLoader] = useState(false)
    const data = history.location.state
    let param = new URLSearchParams(history.location.search)
    useEffect(() => {
        onDetail()
    }, [])
    const formik = useFormik({
        initialValues: {
            corporate_name: '',
            corporate_type: '',
            total_discount: '',
            contact_person: '',
            phone_number: '',
            taxation_details: '',
            corporate_email: '',
            address: ''
        },
        validationSchema: Yup.object({
            corporate_name: Yup.string().required('Required'),
            corporate_type: Yup.string().required('Required'),
            address: Yup.string().required('Required'),
            total_discount: Yup.string()
                .typeError('Must be a number')
                .required("Required"),
            contact_person: Yup.string().required('Required'),
            corporate_email: Yup.string().required('Required').email('Please enter valide email'),
            phone_number: Yup.string()
                .required("Required")
                .min(10, "Too short")
                .max(12, 'Too long'),
            taxation_details: Yup.string().required('Required'),

        }),
        onSubmit: values => {
            setLoader(true)
            let postData = {
                ...values,
                corporate_email:values.corporate_email.toLowerCase(),
                id: param.get('id')
            }
            masterService.update_corporate(postData).then(res => {
                if (res.status) {
                    setLoader(false)
                    history.push('/corporates-list')
                } else {
                    setLoader(false)
                    toast.error(res.message)
                }
            })
        },
    });

    const onDetail = () => {
        let postData = {
            id: param.get('id')
        }
        masterService.get_corporate_details(postData).then(res => {
            if (res.status) {
                formik.setValues({
                    corporate_name: res.data.corporate_name,
                    corporate_type: res.data.corporate_type,
                    phone_number: res.data.phone_number,
                    corporate_email: res.data.corporate_email,
                    address: res.data.address,
                    taxation_details: res.data.taxation_details,
                    total_discount: res.data.total_discount,
                    contact_person: res.data.contact_person,
                })
                console.log(res)
            }
        })
    }

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Corporates Name</label>
                                    <input
                                        required={false}
                                        type="text"
                                        className={'form-control' + (formik.touched.corporate_name ? !formik.errors.corporate_name ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('corporate_name')}
                                        placeholder="Enter Corporates Name"
                                    />
                                    {formik.touched.corporate_name && formik.errors.corporate_name ? (
                                        <div className="text-danger">{formik.errors.corporate_name}</div>
                                    ) : null}
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Corporates Type</label>
                                    <input
                                        required={false}
                                        type="text"
                                        className={'form-control' + (formik.touched.corporate_type ? !formik.errors.corporate_type ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('corporate_type')}
                                        placeholder="Enter Corporate Type"
                                        disabled
                                    />
                                    {formik.touched.corporate_type && formik.errors.corporate_type ? (
                                        <div className="text-danger">{formik.errors.corporate_type}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Contact Person</label>
                                    <input
                                        type="text"
                                        className={'form-control' + (formik.touched.contact_person ? !formik.errors.contact_person ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('contact_person')}
                                        placeholder="Enter Contact Person"

                                    />
                                    {formik.touched.contact_person && formik.errors.contact_person ? (
                                        <div className="text-danger">{formik.errors.contact_person}</div>
                                    ) : null}
                                </div>
                                <div className="mb-3 col-6">
                                    <div className="form-group border">
                                        <label className="form-label">Contact No.</label>
                                        <div
                                            className={(formik.touched.phone_number ? !formik.errors.phone_number ? ' contact-success' : ' contact-error' : '')}
                                        >
                                            <PhoneCode
                                                Addphone={(value) => formik.setValues({ ...formik.values, phone_number: value })}
                                                phone={formik.values.phone_number}
                                            />
                                        </div>
                                    </div>
                                    {formik.touched.phone_number && formik.errors.phone_number ? (
                                        <div className="text-danger">{formik.errors.phone_number}</div>
                                    ) : null}
                                </div>

                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Email ID</label>
                                    <input
                                        type="email"
                                        className={'form-control' + (formik.touched.corporate_email ? !formik.errors.corporate_email ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('corporate_email')}
                                        placeholder="Enter Email"
                                    />
                                    {formik.touched.corporate_email && formik.errors.corporate_email ? (
                                        <div className="text-danger">{formik.errors.corporate_email}</div>
                                    ) : null}
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Registered Address</label>
                                    <input
                                        type="text"
                                        className={'form-control' + (formik.touched.address ? !formik.errors.address ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('address')}
                                        placeholder="Enter Business Address"
                                    />
                                    {formik.touched.address && formik.errors.address ? (
                                        <div className="text-danger">{formik.errors.address}</div>
                                    ) : null}
                                </div>

                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Taxation Details</label>
                                    <input
                                        type="text"
                                        className={'form-control' + (formik.touched.taxation_details ? !formik.errors.taxation_details ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('taxation_details')}
                                        placeholder="Enter Taxation Details"
                                    />
                                    {formik.touched.taxation_details && formik.errors.taxation_details ? (
                                        <div className="text-danger">{formik.errors.taxation_details}</div>
                                    ) : null}
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Total Discount</label>
                                    <input
                                        className={'form-control' + (formik.touched.total_discount ? !formik.errors.total_discount ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('total_discount')}
                                        placeholder="Enter Total Discount"
                                    />
                                    {formik.touched.total_discount && formik.errors.total_discount ? (
                                        <div className="text-danger">{formik.errors.total_discount}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back
                                </button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => formik.handleSubmit()}
                                >Submit
                                </button>
                            </div>
                        </form>
                        <Loader isShow={loader} />
                    </div>
                </div>
            </div>
        </div>
    )
}
